<template>
  <div class="column">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle" style="margin-bottom: 0.8rem;">
      {{ $t(`lockerDelivery.${personType}`) }}
      <b-icon
        :icon="personType === 'courier' ? 'motorcycle' : 'user'"
        style="position: relative;"
        :style="personType === 'courier' ? 'top: 4px;' : 'top: 2px;'"
      ></b-icon>
    </h2>

    <p>
      <b>{{ $t("lockerDelivery.name") }}:</b>
      {{ personInfo.personalInfo.name || "-" }}
    </p>

    <p>
      <b>{{ $t("lockerDelivery.personalId") }}:</b>
      {{ personInfo.personalInfo.personalId || "-" }}
    </p>

    <p>
      <b>{{ $t("lockerDelivery.email") }}:</b>

      <span v-if="isEmailValid(personInfo.personalInfo.email)">
        <a :href="`mailto:${personInfo.personalInfo.email}`" target="_blank">
          {{ personInfo.personalInfo.email }}
        </a>
      </span>

      <span v-else>
        {{ personInfo.personalInfo.email || "-" }}
      </span>

      <small>
        <span @click="showEmailActions = !showEmailActions">
          &nbsp;&nbsp;<u>{{ $t("lockerDelivery.actions") }}</u>
          <b-icon
            :icon="showEmailActions ? 'caret-up' : 'caret-down'"
            size="is-small"
            class="actions-caret"
          ></b-icon>
        </span>
      </small>
    </p>

    <div
      v-show="showEmailActions"
      style="margin-top: 0.5rem; margin-bottom: 0.5rem;"
    >
      &nbsp;

      <button
        class="button is-small action-button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        @click="resendEmail"
        v-show="canResendEmail"
      >
        {{ $t("lockerDelivery.resendLinkEmail") }}
      </button>

      &nbsp;

      <button
        class="button is-small action-button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        @click="updateEmail"
        v-show="canUpdateEmail"
      >
        {{ $t("lockerDelivery.updateEmail") }}
      </button>
    </div>

    <p>
      <b>{{ $t("lockerDelivery.cellphone") }}:</b>

      <a
        :href="
          `https://wa.me/55${personInfo.personalInfo.cellphone.replace(
            /\D/g,
            ''
          )}`
        "
        target="_blank"
        v-if="isCellphoneValid(personInfo.personalInfo.cellphone)"
      >
        {{ personInfo.personalInfo.cellphone }}
        <img
          src="../../../assets/img/logo-whatsapp.png"
          alt=""
          style="position: relative; top: 4px; left: 4px;"
        />
      </a>

      <span v-else>
        {{ personInfo.personalInfo.cellphone || "-" }}
      </span>

      <small>
        <span @click="showCellphoneActions = !showCellphoneActions">
          &nbsp;&nbsp;<u>{{ $t("lockerDelivery.actions") }}</u>
          <b-icon
            :icon="showCellphoneActions ? 'caret-up' : 'caret-down'"
            size="is-small"
            class="actions-caret"
          ></b-icon>
        </span>
      </small>
    </p>

    <div
      v-show="showCellphoneActions"
      style="margin-top: 0.5rem; margin-bottom: 0.5rem;"
    >
      &nbsp;

      <button
        class="button is-small action-button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        @click="resendSMS"
        v-show="canResendSMS"
      >
        {{ $t("lockerDelivery.resendLinkSMS") }}
      </button>

      &nbsp;

      <button
        class="button is-small action-button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        @click="isUpdateCellphoneModalActive = true"
        v-show="canUpdateCellphone"
      >
        {{ $t("lockerDelivery.updateCellphone") }}
      </button>
    </div>

    <p v-if="personType === 'client'" style="margin-top: 0.5rem;">
      <b>{{ $t("lockerDelivery.isWheelchairUser") }}</b>
      {{
        personInfo.personalInfo.wheelchairUser
          ? $t("common.yes")
          : $t("common.no")
      }}
    </p>

    <p style="margin-top: 0.5rem;">
      <b>{{ $t("lockerDelivery.link") }}:</b>
      <a :href="`https://qr.onii.app/${personInfo.shortId}`" target="_blank">
        {{ `qr.onii.app/${personInfo.shortId}` }}
      </a>
    </p>

    <!-- <p>
      <b>{{ $t("lockerDelivery.linkByEmail") }}:</b>
      {{ personInfo.sendEmail ? $t("common.yes") : $t("common.no") }}
    </p>

    <p>
      <b>{{ $t("lockerDelivery.linkBySMS") }}:</b>
      {{ personInfo.sendSMS ? $t("common.yes") : $t("common.no") }}
    </p> -->

    <b-modal :active.sync="isUpdateCellphoneModalActive">
      <update-cellphone-modal
        :personType="personType"
        :deliveryId="deliveryId"
        @cellphone-updated="cellphoneUpdated"
      />
    </b-modal>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";
import updateCellphoneModal from "./UpdateCellphoneModal";

export default {
  props: ["personType", "personInfo", "deliveryId"],

  mixins: [common, mask],

  data() {
    return {
      isLoading: false,
      showEmailActions: false,
      canResendEmail: true,
      canUpdateEmail: true,
      showCellphoneActions: false,
      canResendSMS: true,
      canUpdateCellphone: true,
      isUpdateCellphoneModalActive: false
    };
  },

  components: {
    updateCellphoneModal
  },

  methods: {
    resendEmail() {
      this.$buefy.dialog.confirm({
        title: this.$t("lockerDelivery.areYouSure"),
        message: this.$t("lockerDelivery.noteAboutEmail"),
        confirmText: this.$t("lockerDelivery.yesSend"),
        cancelText: this.$t("common.cancel"),
        type: "is-primary",
        hasIcon: true,
        onConfirm: () => {
          this.isLoading = true;
          this.$store
            .dispatch("resendDeliveryEmail", {
              personType: this.personType,
              deliveryId: this.deliveryId
            })
            .then(res => {
              if (res.data.result === "error") {
                this.alertError(res.data);
              } else {
                this.showEmailActions = false;
                this.canResendEmail = false;
                this.$buefy.toast.open({
                  message: this.$t("lockerDelivery.emailReSent"),
                  type: "is-primary",
                  position: "is-bottom",
                  duration: 5000
                });
              }
            })
            .catch(err => {
              this.alertError(err);
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },

    updateEmail() {
      this.$buefy.dialog.prompt({
        message: this.$t("lockerDelivery.confirmUserEmail"),
        inputAttrs: {
          placeholder: this.personInfo.personalInfo.email
        },
        confirmText: this.$t("lockerDelivery.update"),
        cancelText: this.$t("common.cancel"),
        type: "is-primary",
        onConfirm: email => {
          this.isLoading = true;
          this.$store
            .dispatch("updateDeliveryEmail", {
              personType: this.personType,
              deliveryId: this.deliveryId,
              email
            })
            .then(res => {
              if (res.data.result === "error") {
                this.alertError(res.data);
              } else {
                this.showEmailActions = false;
                this.canUpdateEmail = false;
                this.personInfo.personalInfo.email = email;
                this.$buefy.toast.open({
                  message: this.$t("lockerDelivery.emailUpdated"),
                  type: "is-primary",
                  position: "is-bottom",
                  duration: 5000
                });
              }
            })
            .catch(err => {
              this.alertError(err);
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },

    resendSMS() {
      this.$buefy.dialog.confirm({
        title: this.$t("lockerDelivery.areYouSure"),
        message: this.$t("lockerDelivery.confirmUserCellphone"),
        confirmText: this.$t("lockerDelivery.yesSend"),
        cancelText: this.$t("common.cancel"),
        type: "is-primary",
        hasIcon: true,
        onConfirm: () => {
          this.isLoading = true;
          this.$store
            .dispatch("resendDeliverySMS", {
              personType: this.personType,
              deliveryId: this.deliveryId
            })
            .then(res => {
              if (res.data.result === "error") {
                this.alertError(res.data);
              } else {
                this.showCellphoneActions = false;
                this.canResendSMS = false;
                this.$buefy.toast.open({
                  message: this.$t("lockerDelivery.smsReSent"),
                  type: "is-primary",
                  position: "is-bottom",
                  duration: 5000
                });
              }
            })
            .catch(err => {
              this.alertError(err);
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },

    cellphoneUpdated(cellphone) {
      this.showCellphoneActions = false;
      this.canUpdateCellphone = false;
      this.personInfo.personalInfo.cellphone = cellphone;
    }
  }
};
</script>

<style>
.actions-caret {
  position: relative;
  top: 4px;
}
</style>
